import cn from 'classnames';
import * as React from 'react';

import styles from './styles.module.scss';

export interface DefinitionListProps {
  className?: string;
  children?: string | React.ReactNode;
}

const DefinitionList: React.FC<DefinitionListProps> = ({ ...props }) => {
  return <dl {...props} className={cn(props.className, styles.definitionList)} />;
};

export default DefinitionList;
